import axios from 'axios';
import { attachAuthRefresh } from '../auth/attachAuthRefresh';

const axiosInstance = axios.create({
	baseURL: process.env.REACT_APP_HOST_API,
	headers: {
		'x-user-locale': 'en'
	},
	params: {
		app: "tg",
		ver: "2"
	}
});

attachAuthRefresh(axiosInstance);

export default axiosInstance;
